import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Document } from 'src/app/shared/models/documents/document';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-upload-document-modal',
  templateUrl: './upload-document-modal.component.html',
  styleUrls: ['./upload-document-modal.component.scss']
})
export class UploadDocumentModalComponent implements OnInit {
  public document: Document;
  public clientId: number;
  files: File[] = [];
  @ViewChild('documentModal') documentModal;
  @Output() submit: EventEmitter<Document> = new EventEmitter<Document>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private api: ClientsApiService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute) {
    this.route.parent.data.subscribe(resolversData => {
      this.clientId = resolversData.client.id;
    });
  }

  ngOnInit(): void {
  }

  // handle the popup
  open(document: Document) {
    this.document = document;
    this.modalRef = this.modalService.open(this.documentModal, { centered: true, size: 'lg' });
  }

  close() {
    this.files = [];
    this.modalRef.close();
  }

  onSubmit() {
    this.spinner.show();
    const formData = new FormData();
    this.files.forEach((val, index, arr) => {
      formData.append('document', arr[index]);
    });

    this.api.uploadFileDocument(this.clientId, formData).subscribe(
      r => {
        this.spinner.hide();
        this.submit.emit(r)
      }
    )
  }
  // handle file uploading
  onSelectDoc(event) {
    this.files.push(...event.addedFiles);
  }

  onRemoveDoc(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

}
